import * as amplitude from 'amplitude-js';
import { EnvVars, get } from './config';
import { isEmpty } from 'lodash';
export var AnalyticsEvents;
(function (AnalyticsEvents) {
    AnalyticsEvents["APP_LOAD"] = "App Load";
    AnalyticsEvents["PAGE_LOAD"] = "Page Load";
})(AnalyticsEvents || (AnalyticsEvents = {}));
var Analytics = /** @class */ (function () {
    function Analytics() {
    }
    // must be called upon app initialization
    Analytics.initialize = function () {
        amplitude.init(get(EnvVars.ANALYTICS_AMPLITUDE_KEY), '', {
            batchEvents: true,
        });
    };
    Analytics.identify = function (userId, traits) {
        if (traits === void 0) { traits = {}; }
        return new Promise(function (resolve, reject) {
            amplitude.clearUserProperties();
            amplitude.setUserId(userId);
            if (!isEmpty(traits)) {
                amplitude.setUserProperties(traits);
            }
            resolve();
        });
    };
    Analytics.trackPageLoad = function (name) {
        return this.trackEvent(AnalyticsEvents.PAGE_LOAD, { name: name });
    };
    Analytics.trackEvent = function (event, properties) {
        if (properties === void 0) { properties = {}; }
        return new Promise(function (resolve, reject) {
            //Suppress logging (and the error message) in tests
            if (window.name === 'nodejs') {
                resolve();
                return;
            }
            amplitude.logEvent(event, properties, function (statusCode, response) {
                var done = statusCode < 400 ? resolve : reject;
                done({ statusCode: statusCode, response: response });
            });
        });
    };
    return Analytics;
}());
export { Analytics };
//# sourceMappingURL=analytics.js.map